import { DataApiInputParams } from 'src/types/api';
import { Builder, getHeaders } from './utils';
import { IS_ENCRYPTION_ENABLED } from 'src/config';

export default (builder: Builder) => {
  return {
    updateWordCreditUsage: builder.mutation({
      async queryFn(arg: DataApiInputParams, _, __, baseQuery) {
        let url = `consumptions/word-credits`;
        return baseQuery({
          url: url,
          method: 'POST',
          body: arg.params.formData,
          ...getHeaders(url, arg.params.formData)
        });
      }
    })
  };
};
